import RecentList from './RecentList'

export default RecentList
